import PropTypes from 'prop-types';
// form
import { useFormContext, Controller } from 'react-hook-form';
// @mui
import { TextField, Tooltip } from '@mui/material';

// ----------------------------------------------------------------------

RHFTextField.propTypes = {
  name: PropTypes.string.isRequired, // make name required for proper form behavior
  maxLength: PropTypes.number
};

export default function RHFTextField({
  name,
  maxLength = null,
  isUppercase = false,
  ...other
}) {
  const { control } = useFormContext(); // Use useFormContext to access the form context

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { ref, onChange, ...field }, fieldState: { error } }) => {
        // Handle onChange for uppercase conversion
        const handleOnChange = (e) => {
          // If isUppercase is true, convert input to uppercase
          const value = isUppercase ? e.target.value.toUpperCase() : e.target.value;
          onChange(value); // Update the form value
        };

        // Render TextField wrapped in Tooltip if there's an error
        const inputField = (
          <TextField
            {...field}
            inputRef={ref}
            onChange={handleOnChange} // Apply the custom onChange handler
            fullWidth
            error={!!error}
            inputProps={{ maxLength }} // Apply maxLength to the input field
            {...other} // Spread the remaining props to TextField
          />
        );

        // If there is an error, wrap it with Tooltip
        if (error) {
          return (
            <Tooltip title={error.message} placement="right">
              {inputField}
            </Tooltip>
          );
        }

        // Return just the TextField when there is no error
        return inputField;
      }}
    />
  );
}
